'use strict';

window.urlHelper = (function() {

	var appendDebugParams = function(src) {
		var params = $.getQueryStrings();

		for (var key in params) {
			if (!params.hasOwnProperty(key)) {
				continue;
			}

			if (key.indexOf('..') === 0) {
				var value = params[key];
				var separator = src.indexOf('?') >= 0 ? '&' : '?';
				src += separator + key + '=' + value;
			}
		}

		return src;
	};

	return {
		appendDebugParams: appendDebugParams
	};
})();
